var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"circle",staticClass:"circle-detail rounded-full bg-purple-dark absolute pin m-auto z-0 flex items-center justify-center"},[_c('span',{staticClass:"font-bold tracking-wide leading-tight"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }